module.exports = new __parcel__URL__("bubble-pop.e081c084.gif").toString();